import {
  locationIdFormat,
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const searchProductsAtLocation = {
  name: "searchProductsAtLocation" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    query: z.string().min(1).max(255),
  }),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        hasBinInventory: z.boolean(),
        productFamilyId: productFamilyIdFormat.schema.nullable(),
        productFamilyTitle: z.string().nullable(),
        productFamilyVariantCount: z.number().int().nullable(),
      }),
    ),
  }),
};
